import { createApp, compile } from 'vue';

import { ConfigProvider } from 'ant-design-vue';
import ruRU from 'ant-design-vue/es/locale/ru_RU';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale('ru');

import axios, { CanceledError } from 'axios';
import { message } from 'ant-design-vue';

axios.interceptors.response.use(response => response, error => {

    if (!(error instanceof CanceledError)) {
        message.error(error.message);
    }
    throw error;
})

import DialogSearch from './components/DialogSearch.vue';

const initializeVueApps = () => {
    const elements = document.querySelectorAll('[data-vue-app]:not([data-vue-initialized])');

    elements.forEach((element) => {
        const   component = element.dataset.vueApp,
                slotContent = element.innerHTML;
        
        const app = createApp({
            name: `${component}App`,
            components: {
                ConfigProvider
            },
            data: () => ({
                locale: ruRU,
            }),
            render: compile(/*html*/`
                <ConfigProvider :locale="locale">
                    <${component}>
                        ${slotContent}
                    </${component}>
                </ConfigProvider>
            `)
        });

        app.component('DialogSearch', DialogSearch)
            .mount(element);

        element.setAttribute('data-vue-initialized', 'true');
    })
}

initializeVueApps();

const domObserver = new MutationObserver((mutationRecords) => {
    if (mutationRecords.some(record => record.addedNodes.length > 0)) {
        initializeVueApps();
    }
})

domObserver.observe(document.body, {
    childList: true,
    subtree: true
});

import './main';